export default "__VITE_ASSET__BeqmFMt6__"